<template>
    <transition name="slide-fade" >
        <div>
            <div class="uk-padding">
                <div class="uk-container uk-container-small">
                    <h1 class="uk-heading-line uk-text-center"><span>Charities and Non-Profit Services</span></h1>
                    <ul class="uk-list uk-list-bullet">
                        We can assist with meeting the disclosure and regulatory requirements for
                        Boards, the NPO Law, and other key stakeholders by preparing:
                        <li>Balance Sheet: showing the position for assets, liabilities and residual equity;</li>
                        <li>Income Statement: which shows the sources of income and areas of expenditures in operating the organization;</li>
                        <li>Statement of Cost of Function: which shows all the expenses allocated to either program services, fundraising, or operations;</li>
                        <li>Individual Program Expense Statements: which report the expenses for each program or service; and</li>
                        <li>Revenue Support Schedules: which detail the organization's sources of income in specific categories such as assessments, charitable
                            donations, membership fees, investment income.</li>

                    </ul>

                    <ul class="uk-list uk-list-divider deeper">
                        <span style="color: rgb(197,179,88);">To achieve this FINCOR will:</span> <br>
                        <li>Review and compile your financial statements;</li>
                        <li>Design, install, and maintain your Accounting System;</li>
                        <li>Prepare your payroll on Weekly, bi-weekly, or monthly basis;</li>
                        <li>Prepare Bank Deposits;</li>
                        <li>Provide training for your accounting personnel where necessary;</li>
                        <li>Provide training for your board to understand financial statements and
                            effective budgeting practices; and</li>
                        <li>Assist in compliance activities such as pension and health insurance schemes.</li>
                    </ul>

                    <!--<ul class="uk-list uk-list-bullet">
                        Our client list includes the following organizations:
                        <li>Home owners Associations (Strata)</li>
                        <li>Religious Institutions</li>
                        <li>Sporting Clubs</li>
                        <li>Boards and Committees</li>
                        <li>Charities</li>
                    </ul>-->
                </div>
            </div>
            <div class="uk-padding uk-background-muted uk-margin-remove-bottom">
                <div class="uk-container ">
                    <h3 class="uk-heading-bullet specHeading uk-text-bold">Clients currently served:</h3>
                    <div class="uk-child-width-1-4@m" uk-grid>
                        <div>
                            <div>
                                <div class="uk-card uk-card-default">
                                    <div class="uk-card-media-top">
                                        <img src="../assets/alcoholic-beverages-beverage-celebration-2105511.jpg" alt="">
                                    </div>
                                    <div class="uk-card-body" style="padding: 10px;">
                                        <h5 class="specHeading uk-text-bold">Home Owners Association (Strata)</h5>

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div>
                            <div>
                                <div class="uk-card uk-card-default">
                                    <div class="uk-card-media-top">
                                        <img src="../assets/united-church.png" alt="">
                                    </div>
                                    <div class="uk-card-body" style="padding: 10px;">
                                        <h5 class="specHeading uk-text-bold">Religious Institutions</h5>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div>
                            <div>
                                <div class="uk-card uk-card-default">
                                    <div class="uk-card-media-top">
                                        <img src="../assets/cifa.png" alt="">
                                    </div>
                                    <div class="uk-card-body" style="padding: 10px;">
                                        <h5 class="specHeading uk-text-bold">Sporting Clubs</h5>

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div>
                            <div>
                                <div class="uk-card uk-card-default">
                                    <div class="uk-card-media-top">
                                        <img src="../assets/adult-boardroom-chairs-1181304.jpg" alt="">
                                    </div>
                                    <div class="uk-card-body" style="padding: 10px;">
                                        <h5 class="specHeading uk-text-bold">Boards and Committees</h5>

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div>
                            <div>
                                <div class="uk-card uk-card-default">
                                    <div class="uk-card-media-top">
                                        <img src="../assets/care-charity-community-service-1559106.jpg" alt="">
                                    </div>
                                    <div class="uk-card-body" style="padding: 10px;">
                                        <h5 class="specHeading uk-text-bold">Charities</h5>

                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "charitiesAndNonProfits",
      metaInfo: {
        title: ' Charities and Non-Profit Financial Services',
        meta: [{
          content: 'We can assist with meeting the disclosure and regulatory requirements for Boards, the NPO Law, and other key stakeholders by preparing all necessary work for your charities and non-profit services.'
        }]
      }
    }
</script>

<style scoped>
    .deeper li{
        margin-left: 30px;

    }
    img{
      border-radius: 5px;
    }
</style>